
import React from 'react';
import Layout from '@/components/Layout';
import SupportChat from '@/components/SupportChat';
import ProtectedRoute from '@/components/ProtectedRoute';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const SupportPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleCloseChat = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <ProtectedRoute>
      <Layout>
        <div className="flex items-start justify-center p-4 pt-16">
          <SupportChat onClose={handleCloseChat} />
        </div>
      </Layout>
    </ProtectedRoute>
  );
};

export default SupportPage;
